/**
 * Gestione Mense Backend Authentication API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface PasskeyLoginOptionsResponse { 
    /**
     * Challenge casuale codificato in Base64URL
     */
    challenge: string;
    /**
     * Identificativo della Relying Party (dominio)
     */
    rp_id: string;
    /**
     * Lista di credential ID ammessi, codificati in Base64URL
     */
    allow_credentials: Array<string>;
    /**
     * Session ID da rimandare in /login/verify (UUID)
     */
    session_id: string;
}